/// <amd-module name="Wiki/PageRenamePanel/Sources/WikiPagesSource" />
import { ILegacyPlatformService } from "VSS/Legacy/Legacy";
import { IVssPageContext } from "VSS/Platform/Context";

import * as VCContracts from "Wiki/Clients/VC/Contracts/Git";
import { WikiPage, WikiPageResponse, WikiV2 } from "Wiki/Clients/Wiki/Contracts/Wiki";
import { getWikiClient } from "Wiki/Clients/Wiki/RestClient/Wiki";
import { WikiPageInfo } from "Wiki/ViewCommon/Contracts";
import { flattenWikiPage } from "Wiki/ViewCommon/Utils/PageHelper";

export class WikiPagesSource {
    constructor(private _pageContext: IVssPageContext) {}

    public getPageInfo(wiki: WikiV2, pagePath: string, version?: VCContracts.GitVersionDescriptor): Promise<WikiPageInfo> {
        return getWikiClient(this._pageContext)
            .getPage(wiki.projectId, wiki.id, pagePath, VCContracts.VersionControlRecursionType.None, version, true)
            .then((pageResponse: WikiPageResponse) => {
                return {
                    ...pageResponse.page,
                    version: pageResponse.eTag[0]
                };
            });
    }

    public savePage(wiki: WikiV2, pagePath: string, content: string, version: string, comment: string): Promise<WikiPageResponse> {
        const legacyPlatformService = this._pageContext.getService<ILegacyPlatformService>("ILegacyPlatformService");

        return legacyPlatformService.requireModules(["Mention/Scripts/TFS.Mention"]).then(([mentionProcessor]) => {
            return getWikiClient(this._pageContext).createOrUpdatePage(
                {
                    content: mentionProcessor.MentionProcessor.getDefault().translateDisplayNamesToStorageKeysOfPersonMentions(content)
                },
                wiki.projectId,
                wiki.id,
                pagePath,
                version,
                comment
            );
        });
    }

    /**
     * Gets the page requested and its subpages if any
     * @param pagePath
     */
    public getPageAndSubPages(
        wiki: WikiV2,
        pagePath: string,
        version: VCContracts.GitVersionDescriptor | undefined,
        recursionLevel = VCContracts.VersionControlRecursionType.OneLevelPlusNestedEmptyFolders
    ): Promise<WikiPage[]> {
        return getWikiClient(this._pageContext)
            .getPage(wiki.projectId, wiki.id, pagePath, recursionLevel, version)
            .then((pageResponse: WikiPageResponse) => {
                return flattenWikiPage(pageResponse.page);
            });
    }
}
